import { Dispatch, AnyAction }                                                                                        from 'redux';
import { AppState }                                                                                                   from '../redux';
import {
  STORE_RATING,
  STORE_COMMENTS,
  STORE_GENERALVALUE,
  STORE_ANTERIORVALUE,
  STORE_COPINGVALUE,
  STORE_MODELVALUE,
  STORE_ABUTMENTVALUE,
  STORE_CUTBACKVALUE,
  STORE_FBTYPE,
  STORE_CHECKEDVALUE,
  STORE_FILES_SUBMITFBATTACHMENT,
} from '../reducers/feedback';
// import { STORE_ERROR_MESSAGE, STORE_ERROR_BAR } from '../reducers/errors';
import { STORE_ERROR_MESSAGE, STORE_ERROR_BAR, STORE_SUCCESS_FILES_UPLOADED, STORE_SUCCESS_FILES_UPLOADED_MSG, 
STORE_ERROR_FILES_UPLOADED_MSG, STORE_ERROR_FILES_UPLOADED } from '../reducers/errors';

import axios, { AxiosResponse }                                                                                       from 'axios';
import { push }                                                                                                       from 'react-router-redux';
import { STORE_LOADER, STORE_SEARCHNAME, STORE_SEARCHTRUE }                                                           from 'src/reducers/landingPage';
import { STORE_COMPLETEDATA_ORDERNO, STORE_VIEWCOMPLETEDORDER, STORE_VIEWFEEDBACK, ViewCompletedOrder, ViewFeedback } from 'src/reducers/completeorderfile';
import { STORE_LIVEDATA_ORDERID }                                                                                     from 'src/reducers/liveorderfile';
import { STORE_RXORDERDATA }                                                                                          from 'src/reducers/rxForm';
import { clearDataOnOpen }                                                                                            from './rxformAction';

export const saveComments = (comments: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_COMMENTS, comments } as AnyAction);
    return true;
  };
};
 
export const saveFbType = (fbtype: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const allValues = [...(getState().feedback.Checked || [])]; // Ensure it's grabbing the correct state
    const typeArray = fbtype.split(','); 
    const filteredValues = allValues.filter(item => typeArray.includes(item.Type));
    dispatch({ type: STORE_CHECKEDVALUE, payload: filteredValues });

    dispatch({ type: STORE_FBTYPE, fbtype } as AnyAction);
    return true;
  };
};

export const saveRating = (rating: number) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    if (rating !== null) {
      dispatch({ type: STORE_RATING, rating } as AnyAction);
      if (rating === 5) {
        dispatch({ type: STORE_FILES_SUBMITFBATTACHMENT, submitFbFiles: [] });
      }
    }
    return true;
  };
};
export const checkedValuesGeneral = (event: React.ChangeEvent<HTMLInputElement>) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    if (event.target.checked) {
      const oldValues = [...getState().feedback.General];
      const NewValues = oldValues.concat([event.target.value as string]);

      const seen = new Set();
      const General = NewValues.filter(el => {
        const duplicate = seen.has(el);
        seen.add(el);
        return !duplicate;
      });
      dispatch({ type: STORE_GENERALVALUE, General } as AnyAction);

    } else {
      const oldValues = [...getState().feedback.General];
      const General = oldValues.filter(e => {
        return e !== (event.target.value as string);
      });
      dispatch({ type: STORE_GENERALVALUE, General } as AnyAction);

    }
    return true;
  };
};

export const handleCheckboxChange = (
  feedbacktype: string,
  listtype: string,
  checked: boolean
) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const oldValues = [...(getState().feedback.Checked || [])]; // Ensure it's grabbing the correct state
    if (checked) {
      const newValue = { Type: feedbacktype, Params: listtype };
      // Dispatch action with updated Checked array
      dispatch({ type: STORE_CHECKEDVALUE, payload: [...oldValues, newValue] });
    } else {
      const updatedValues = oldValues.filter(
        (item) => item.Type !== feedbacktype || item.Params !== listtype
      );    
      // Dispatch action with updated Checked array      
      dispatch({ type: STORE_CHECKEDVALUE, payload: updatedValues });
    }
  };
};

// export const handleCheckboxChange = (
//   feedbacktype: string, 
//   listtype: string, 
//   checked: boolean
// ) => {
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//       const oldValues = [...(getState().feedback.Checked || [])];
      
//       if (checked) {
//           // Check if the exact combination already exists
//           const existingItemIndex = oldValues.findIndex(
//               item => item.Type === feedbacktype && item.Params === listtype
//           );
          
//           // Only add if it doesn't already exist
//           if (existingItemIndex === -1) {
//               const newValue = { Type: feedbacktype, Params: listtype };
//               dispatch({ 
//                   type: STORE_CHECKEDVALUE, 
//                   payload: [...oldValues, newValue] 
//               });
//           }
//       } else {
//           // Remove the specific combination
//           const updatedValues = oldValues.filter(
//               (item) => !(item.Type === feedbacktype && item.Params === listtype)
//           );
          
//           dispatch({ 
//               type: STORE_CHECKEDVALUE, 
//               payload: updatedValues 
//           });
//       }
//   };
// };

export const onFilesChange = (fileatBox: Array<File>) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
      const currentRating = getState()?.feedback?.rating;
      // Early return if no files
      // if (fileatBox.length === 0) {
      if (currentRating === 5) {
          dispatch({ type: STORE_FILES_SUBMITFBATTACHMENT, submitFbFiles: [] });
          return;
      }

      // Add filename property to each file
      const filesWithNames = fileatBox.map((file, index) => {
          const x = fileatBox[index];
          Object.defineProperties(x, {
              'filename': {
                  value: file.name,
                  writable: true,
                  enumerable: true
              }
          });
          return x;
      });

      // Safely get existing files or use empty array if undefined
      const existingFiles = getState()?.feedback?.submitFbFiles || [];
      
      // Combine with existing files and remove duplicates
      const filterfile = existingFiles.concat(filesWithNames);
      const seen = new Set();
      const submitFbFiles = filterfile.filter(el => {
          const duplicate = seen.has(JSON.parse(JSON.stringify(el)).filename);
          seen.add(JSON.parse(JSON.stringify(el)).filename);
          return !duplicate;
      });

      if (submitFbFiles.length > 0) {
          dispatch({ type: STORE_FILES_SUBMITFBATTACHMENT, submitFbFiles });
      }
  };
};

export const onFilesError = (error: Error, images: Array<File>) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
      // ==> console.error(error.message);
      // images.length = 0;
  };
};

export const deleteRowbyId = (event: React.ChangeEvent<{ value: string }>) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
      const currentFiles = getState()?.feedback?.submitFbFiles || [];
      
      // Get the filename from event value
      const filenameToDelete = event.currentTarget.value;

      // Create new array without the file to delete
      const updatedFiles = currentFiles.filter(file => {
          const fileData = JSON.parse(JSON.stringify(file));
          return fileData.filename !== filenameToDelete;
      });

      // Dispatch the updated files array
      dispatch({ 
          type: STORE_FILES_SUBMITFBATTACHMENT, 
          submitFbFiles: updatedFiles 
      });
  };
};

export const viewRateData = (
  orderno: string,
  dsorderid: string
) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const sessionid = getState().user.userDetails.s || '';
    const submitApiUrl = `${getState().environment.API_URL}getOrderDetails?orderId=${encodeURIComponent(
      dsorderid || ''
    )}`;
    const viewApiUrl = `${getState().environment.API_URL}getFeedbackData?porderno=${encodeURIComponent(
      orderno || ''
    )}`;

    // Dispatch initial actions
    dispatch({ type: STORE_SEARCHNAME, searchName: '' } as AnyAction);
    dispatch({ type: STORE_SEARCHTRUE, searchTrue: false } as AnyAction);
    dispatch({ type: STORE_COMPLETEDATA_ORDERNO, dsorderid } as AnyAction);
    dispatch({ type: STORE_LIVEDATA_ORDERID, orderno } as AnyAction);
    dispatch({ type: STORE_RXORDERDATA, userRxdata: [] } as AnyAction);

    // Clear data utility
    clearDataOnOpen(dispatch, getState);

    // Show loader
    dispatch({ type: STORE_LOADER, loader: true } as AnyAction);

    try {
      // Fetch order details
      const response = await axios.post(submitApiUrl, null, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          sessionid: sessionid,
        },
      });

      const viewCompleteOrder: ViewCompletedOrder[] = response.data || [];
      dispatch({ type: STORE_VIEWCOMPLETEDORDER, viewCompleteOrder } as AnyAction);

      // Fetch feedback data
      const feedbackResponse = await axios.get(viewApiUrl, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          sessionid: sessionid,
        },
      });

      const viewFeedback: ViewFeedback = feedbackResponse.data || {};
      dispatch({ type: STORE_VIEWFEEDBACK, viewFeedback } as AnyAction);

      // Navigate to feedback page
      dispatch(push('/app/viewfeedback'));
    } catch (error) {
      console.error('Error fetching order or feedback details:', error.message);

      // Reset state on error
      dispatch({ type: STORE_VIEWCOMPLETEDORDER, viewCompleteOrder: [] } as AnyAction);
      dispatch({ type: STORE_VIEWFEEDBACK, viewFeedback: {} } as AnyAction);
    } finally {
      // Hide loader
      dispatch({ type: STORE_LOADER, loader: false } as AnyAction);
    }
  };
};

export const checkedValuesAnterior = (event: React.ChangeEvent<HTMLInputElement>) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    if (event.target.checked) {
      const oldValues = [...getState().feedback.Anterior];
      const NewValues = oldValues.concat([event.target.value as string]);

      const seen = new Set();
      const Anterior = NewValues.filter(el => {
        const duplicate = seen.has(el);
        seen.add(el);
        return !duplicate;
      });
      dispatch({ type: STORE_ANTERIORVALUE, Anterior } as AnyAction);

    } else {
      const oldValues = [...getState().feedback.Anterior];
      const Anterior = oldValues.filter(e => {
        return e !== (event.target.value as string);
      });
      dispatch({ type: STORE_ANTERIORVALUE, Anterior } as AnyAction);

    }
    return true;
  };
};

export const checkedValuesCopings = (event: React.ChangeEvent<HTMLInputElement>) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    if (event.target.checked) {
      const oldValues = [...getState().feedback.Copings];
      const NewValues = oldValues.concat([event.target.value as string]);

      const seen = new Set();
      const Copings = NewValues.filter(el => {
        const duplicate = seen.has(el);
        seen.add(el);
        return !duplicate;
      });
      dispatch({ type: STORE_COPINGVALUE, Copings } as AnyAction);

    } else {
      const oldValues = [...getState().feedback.Copings];
      const Copings = oldValues.filter(e => {
        return e !== (event.target.value as string);
      });
      dispatch({ type: STORE_COPINGVALUE, Copings } as AnyAction);

    }
    return true;
  };
};
export const checkedValuesModel = (event: React.ChangeEvent<HTMLInputElement>) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    if (event.target.checked) {
      const oldValues = [...getState().feedback.Model];
      const NewValues = oldValues.concat([event.target.value as string]);

      const seen = new Set();
      const Model = NewValues.filter(el => {
        const duplicate = seen.has(el);
        seen.add(el);
        return !duplicate;
      });
      dispatch({ type: STORE_MODELVALUE, Model } as AnyAction);

    } else {
      const oldValues = [...getState().feedback.Model];
      const Model = oldValues.filter(e => {
        return e !== (event.target.value as string);
      });
      dispatch({ type: STORE_MODELVALUE, Model } as AnyAction);

    }
    return true;
  };
};
export const checkedValuesAbutment = (event: React.ChangeEvent<HTMLInputElement>) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    if (event.target.checked) {
      const oldValues = [...getState().feedback.Abutment];
      const NewValues = oldValues.concat([event.target.value as string]);

      const seen = new Set();
      const Abutment = NewValues.filter(el => {
        const duplicate = seen.has(el);
        seen.add(el);
        return !duplicate;
      });
      dispatch({ type: STORE_ABUTMENTVALUE, Abutment } as AnyAction);

    } else {
      const oldValues = [...getState().feedback.Abutment];
      const Abutment = oldValues.filter(e => {
        return e !== (event.target.value as string);
      });
      dispatch({ type: STORE_ABUTMENTVALUE, Abutment } as AnyAction);

    }
    return true;
  };
};
export const checkedValuesCutback = (event: React.ChangeEvent<HTMLInputElement>) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    if (event.target.checked) {
      const oldValues = [...getState().feedback.Cutback];
      const NewValues = oldValues.concat([event.target.value as string]);

      const seen = new Set();
      const Cutback = NewValues.filter(el => {
        const duplicate = seen.has(el);
        seen.add(el);
        return !duplicate;
      });
      dispatch({ type: STORE_CUTBACKVALUE, Cutback } as AnyAction);

    } else {
      const oldValues = [...getState().feedback.Cutback];
      const Cutback = oldValues.filter(e => {
        return e !== (event.target.value as string);
      });
      dispatch({ type: STORE_CUTBACKVALUE, Cutback } as AnyAction);

    }
    return true;
  };
};

export const resetFields = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
  const checkboxAll = Array.from(document.querySelectorAll<HTMLInputElement>('#checkBox'));
  if (checkboxAll !== null) {
    checkboxAll.forEach((each, index) => {
      if (each.checked === true) {
        each.click();
      }
    });
  }

  dispatch({ type: STORE_COMMENTS, comments: '' } as AnyAction);
  dispatch({ type: STORE_RATING, rating: 5 } as AnyAction);
  dispatch({ type: STORE_FBTYPE, fbtype: '' } as AnyAction);
  // dispatch({ type: STORE_FBTYPE, fbtype: [] } as AnyAction);
  dispatch({ type: STORE_GENERALVALUE, General: [] } as AnyAction);
  dispatch({ type: STORE_ANTERIORVALUE, Anterior: [] } as AnyAction);
  dispatch({ type: STORE_COPINGVALUE, Copings: [] } as AnyAction);
  dispatch({ type: STORE_CHECKEDVALUE, checkedValue: [] } as AnyAction);
  dispatch({ type: STORE_FILES_SUBMITFBATTACHMENT, submitFbFiles: [] } as AnyAction);
  return true;
};

export const fbpmresetFields = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
  const checkedValue: Array<string> = [];
  const checkboxAll = Array.from(document.querySelectorAll<HTMLInputElement>('#checkBox'));
  if (checkboxAll !== null) {
    checkboxAll.forEach((each, index) => {
      if (each.checked === true) {
        each.click();
      }
    });
  }
  dispatch({ type: STORE_CHECKEDVALUE, checkedValue } as AnyAction);
  return true;
};

// export const doFeedback = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

//   interface CheckedData {
//     Type: string;
//     Params: string;
//   }
  
//   const feedback = {
//     transid: 'feedb',
//     recid: '0',
//     orderno: '',
//     status: 0,
//     general: '',
//     anterior: '',
//     copings: '',
//     model: '',
//     abutment: '',
//     cutback: '',
//     comments: '',
//     fbtype: '',
//     Checked: [] as CheckedData[],  // Initialize as an empty array of CheckedData objects
//     submitFbFiles: [] as File[]
//   };
//   console.log(feedback, 'feedbackfeedback');
//   feedback.status = getState().feedback.rating;
//   feedback.orderno = getState().completeOrder.viewCompleteOrder[0].orderno;
//   feedback.general = [...getState().feedback.General].toString();
//   feedback.anterior = [...getState().feedback.Anterior].toString();
//   feedback.copings = [...getState().feedback.Copings].toString();
//   feedback.model = [...getState().feedback.Model].toString();
//   feedback.abutment = [...getState().feedback.Abutment].toString();
//   feedback.cutback = [...getState().feedback.Cutback].toString();
//   feedback.comments = getState().feedback.comments;
//   feedback.fbtype = getState().feedback.fbtype;
//   feedback.Checked = getState().feedback.Checked;
//   feedback.submitFbFiles = getState().feedback.submitFbFiles || [];
//   if (feedback.status === 0) {
//     const errorBar = true;
//     const errorMessage = 'Please provide any rating';
//     dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
//     dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
//     return;
//   } else {
//     const errorBar = false;
//     dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
//   }
//   setTimeout(() => { dispatch(push('/app/rxform')); }, 3000);

//   await axios({
//     method: 'post',
//     url: `${getState().environment.API_URL}updateFeedback`,
//     data: feedback,
//     headers: {
//       'Access-Control-Allow-Origin': '*',
//       'Content-Type': 'application/json',
//       sessionid: getState().user.userDetails.s || '',
//       orderid: getState().liveOrder.orderid,
//       sourcetype: 'Feedback',
//       dsorderid: '',
//       filepath: getState().completeOrder.viewCompleteOrder[0].fpath || ''
//     }
//   }).then(function (response: AxiosResponse) {
//     const checkboxAll = Array.from(document.querySelectorAll<HTMLInputElement>('#checkBox'));
//     if (checkboxAll !== null) {
//       checkboxAll.forEach((each, index) => {
//         if (each.checked === true) {
//           each.click();
//         }
//       });
//     }

//     dispatch({ type: STORE_COMMENTS, comments: '' } as AnyAction);
//     dispatch({ type: STORE_FBTYPE, fbtype: '' } as AnyAction);
//     dispatch({ type: STORE_RATING, rating: 5 } as AnyAction);
//     dispatch({ type: STORE_GENERALVALUE, General: [] } as AnyAction);
//     dispatch({ type: STORE_ANTERIORVALUE, Anterior: [] } as AnyAction);
//     dispatch({ type: STORE_COPINGVALUE, Copings: [] } as AnyAction);
//     dispatch({ type: STORE_CHECKEDVALUE, checkedValue: [] } as AnyAction);
//     dispatch({ type: STORE_FILES_SUBMITFBATTACHMENT, submitFbFiles : [] } as AnyAction);

//     const successFileUploadOpen = true;
//     const successfilemsg = `Thank you for your valuable Feedback`;
//     dispatch({ type: STORE_SUCCESS_FILES_UPLOADED_MSG, successfilemsg } as AnyAction);
//     dispatch({ type: STORE_SUCCESS_FILES_UPLOADED, successFileUploadOpen } as AnyAction);

//     dispatch(push('/app/rxform'));

//   }).catch(error => {
//     const errorFileUploadedOpen = true;
//     const errorfilemsg = error.response.data.msg;
//     dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//     dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//   });
// };

// export const doFeedback = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//   interface CheckedData {
//     Type: string;
//     Params: string;
//   }

//   interface AttachmentData {
//     attachmentname: string;
//     attachfilename: string;
//   }
  
//   const feedback = {
//     transid: 'feedb',
//     recid: '0',
//     orderno: '',
//     status: 0,
//     general: '',
//     anterior: '',
//     copings: '',
//     model: '',
//     abutment: '',
//     cutback: '',
//     comments: '',
//     fbtype: '',
//     Checked: [] as CheckedData[],
//     submitFbFiles: [] as File[],
//     attachments: [] as AttachmentData[]
//   };

//   feedback.status = getState().feedback.rating;
//   feedback.orderno = getState().completeOrder.viewCompleteOrder[0].orderno;
//   feedback.general = [...getState().feedback.General].toString();
//   feedback.anterior = [...getState().feedback.Anterior].toString();
//   feedback.copings = [...getState().feedback.Copings].toString();
//   feedback.model = [...getState().feedback.Model].toString();
//   feedback.abutment = [...getState().feedback.Abutment].toString();
//   feedback.cutback = [...getState().feedback.Cutback].toString();
//   feedback.comments = getState().feedback.comments;
//   feedback.fbtype = getState().feedback.fbtype;
//   feedback.Checked = getState().feedback.Checked;
//   feedback.submitFbFiles = getState().feedback.submitFbFiles || [];

//   if (feedback.status === 0) {
//     const errorBar = true;
//     const errorMessage = 'Please provide any rating';
//     dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
//     dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
//     return;
//   } else {
//     const errorBar = false;
//     dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
//   }

//   // Handle file uploads first if files exist
//   if (feedback.submitFbFiles.length > 0) {
//     for (const file of feedback.submitFbFiles) {
//       const formData = new FormData();
//       formData.append('filetoattach', file);

//       try {
//         const response = await axios({
//           method: 'post',
//           url: `${getState().environment.API_URL}attachMessageFile`,
//           data: formData,
//           headers: {
//             'Content-Type': 'multipart/form-data',
//             orderid: getState().liveOrder.orderid,
//             sourcetype: 'Feedback',
//             dsorderid: '',
//             sessionid: getState().user.userDetails.s || '',
//             filepath: getState().completeOrder.viewCompleteOrder[0].fpath || ''
//           }
//         });

//         if (response.data.status) {
//           feedback.attachments.push({
//             attachmentname: response.data.fileName,
//             attachfilename: `${response.data.location}/${response.data.fileName}`
//           });
//         }
//       } catch (error) {
//         console.error('File upload failed:', error);
//         const errorFileUploadedOpen = true;
//         const errorfilemsg = error.response?.data?.msg || 'File upload failed';
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//         throw error;
//       }
//     }
//   }

//   setTimeout(() => { dispatch(push('/app/rxform')); }, 3000);

//   // Send feedback data after handling files
//   await axios({
//     method: 'post',
//     url: `${getState().environment.API_URL}updateFeedback`,
//     data: feedback,
//     headers: {
//       'Access-Control-Allow-Origin': '*',
//       'Content-Type': 'application/json',
//       sessionid: getState().user.userDetails.s || '',
//       orderid: getState().liveOrder.orderid,
//       sourcetype: 'Feedback',
//       dsorderid: '',
//       filepath: getState().completeOrder.viewCompleteOrder[0].fpath || ''
//     }
//   }).then(function (response: AxiosResponse) {
//     const checkboxAll = Array.from(document.querySelectorAll<HTMLInputElement>('#checkBox'));
//     if (checkboxAll !== null) {
//       checkboxAll.forEach((each, index) => {
//         if (each.checked === true) {
//           each.click();
//         }
//       });
//     }

//     dispatch({ type: STORE_COMMENTS, comments: '' } as AnyAction);
//     dispatch({ type: STORE_FBTYPE, fbtype: '' } as AnyAction);
//     dispatch({ type: STORE_RATING, rating: 5 } as AnyAction);
//     dispatch({ type: STORE_GENERALVALUE, General: [] } as AnyAction);
//     dispatch({ type: STORE_ANTERIORVALUE, Anterior: [] } as AnyAction);
//     dispatch({ type: STORE_COPINGVALUE, Copings: [] } as AnyAction);
//     dispatch({ type: STORE_CHECKEDVALUE, checkedValue: [] } as AnyAction);
//     dispatch({ type: STORE_FILES_SUBMITFBATTACHMENT, submitFbFiles: [] } as AnyAction);

//     const successFileUploadOpen = true;
//     const successfilemsg = `Thank you for your valuable Feedback`;
//     dispatch({ type: STORE_SUCCESS_FILES_UPLOADED_MSG, successfilemsg } as AnyAction);
//     dispatch({ type: STORE_SUCCESS_FILES_UPLOADED, successFileUploadOpen } as AnyAction);

//     dispatch(push('/app/rxform'));

//   }).catch(error => {
//     const errorFileUploadedOpen = true;
//     const errorfilemsg = error.response?.data?.msg || 'Feedback submission failed';
//     dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//     dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//   });
// };
// In your feedbackaction.tsx file

export const doFeedback = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
  interface CheckedData {
    Type: string;
    Params: string;
  }

  interface AttachmentData {
    attachmentname: string;
    attachfilename: string;
  }
  
  const feedback = {
    transid: 'feedb',
    recid: '0',
    orderno: '',
    status: 0,
    general: '',
    anterior: '',
    copings: '',
    model: '',
    abutment: '',
    cutback: '',
    comments: '',
    fbtype: '',
    Checked: [] as CheckedData[],
    submitFbFiles: [] as File[],
    attachments: [] as AttachmentData[]
  };

  feedback.status = getState().feedback.rating;
  feedback.orderno = getState().completeOrder.viewCompleteOrder[0].orderno;
  feedback.general = [...getState().feedback.General].toString();
  feedback.anterior = [...getState().feedback.Anterior].toString();
  feedback.copings = [...getState().feedback.Copings].toString();
  feedback.model = [...getState().feedback.Model].toString();
  feedback.abutment = [...getState().feedback.Abutment].toString();
  feedback.cutback = [...getState().feedback.Cutback].toString();
  feedback.comments = getState().feedback.comments;
  feedback.fbtype = getState().feedback.fbtype;
  feedback.Checked = getState().feedback.Checked;
  feedback.submitFbFiles = getState().feedback.submitFbFiles || [];

  if (feedback.status === 0) {
    const errorBar = true;
    const errorMessage = 'Please provide any rating';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  }

  // Handle file uploads first if files exist
  if (feedback.submitFbFiles.length > 0) {
    for (const file of feedback.submitFbFiles) {
      const formData = new FormData();
      formData.append('filetoattach', file);

      try {
        const response = await axios({
          method: 'post',
          url: `${getState().environment.API_URL}attachMessageFile`,
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
            orderid: getState().liveOrder.orderid,
            sourcetype: 'Feedback',
            dsorderid: '',
            sessionid: getState().user.userDetails.s || '',
            filepath: getState().completeOrder.viewCompleteOrder[0].fpath || ''
          }
        });

        if (response.data.status) {
          feedback.attachments.push({
            attachmentname: response.data.fileName,
            attachfilename: `${response.data.location}/${response.data.fileName}`
          });
        }
      } catch (error) {
        console.error('File upload failed:', error);
        const errorFileUploadedOpen = true;
        const errorfilemsg = error.response?.data?.msg || 'File upload failed';
        dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
        dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
        throw error;
      }
    }
  }
  // Then in your doFeedback function, update the axios call:
 
  // dispatch(push('/app/rxform'));
  dispatch(push('/app/completeOrders'));
  // setTimeout(() => window.location.reload(), 1000);

  await axios({
    method: 'post',
    url: `${getState().environment.API_URL}updateFeedback`,
    data: feedback,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      sessionid: getState().user.userDetails.s || '',
      orderid: getState().liveOrder.orderid,
      sourcetype: 'Feedback',
      dsorderid: '',
      filepath: getState().completeOrder.viewCompleteOrder[0].fpath || ''
    }
  })

  .then(function(response: AxiosResponse) {
    const checkboxAll = Array.from(document.querySelectorAll<HTMLInputElement>('#checkBox'));
    if (checkboxAll !== null) {
      checkboxAll.forEach((each, index) => {
        if (each.checked === true) {
          each.click();
        }
      });
    }

    dispatch({ type: STORE_COMMENTS, comments: '' } as AnyAction);
    dispatch({ type: STORE_FBTYPE, fbtype: '' } as AnyAction);
    dispatch({ type: STORE_RATING, rating: 5 } as AnyAction);
    dispatch({ type: STORE_GENERALVALUE, General: [] } as AnyAction);
    dispatch({ type: STORE_ANTERIORVALUE, Anterior: [] } as AnyAction);
    dispatch({ type: STORE_COPINGVALUE, Copings: [] } as AnyAction);
    dispatch({ type: STORE_CHECKEDVALUE, checkedValue: [] } as AnyAction);
    dispatch({ type: STORE_FILES_SUBMITFBATTACHMENT, submitFbFiles: [] } as AnyAction);

    const successFileUploadOpen = true;
    const successfilemsg = `Thank you for your valuable Feedback`;
    dispatch({ type: STORE_SUCCESS_FILES_UPLOADED_MSG, successfilemsg } as AnyAction);
    dispatch({ type: STORE_SUCCESS_FILES_UPLOADED, successFileUploadOpen } as AnyAction);

    // dispatch(push('/app/rxform'));
    dispatch(push('/app/completeOrders'));
    setTimeout(() => window.location.reload(), 1000);
    // setTimeout(() => { if (window.history && window.history.go) { window.history.go(0); } else { window.location.replace(window.location.href); } }, 100);
  })
  
  .catch(error => {
    const errorFileUploadedOpen = true;
    const errorfilemsg = error.response?.data?.msg || 'Feedback submission failed';
    dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
  });
};

export const initiateLogin = async (
  dispatch: Dispatch<AppState>,
  getState: () => AppState
) => {
  const url = document.location!!.href;
  let loadUrl = url;
  var cnt = 0;
  var ind = 0;
  while (cnt !== 3) {
    ind = loadUrl.indexOf('/', ind) + 1;
    cnt++;
  }
  loadUrl = loadUrl.substring(0, ind);

  const callbackUrl = loadUrl;
  let responseType: string | undefined = getState().environment.ENV_MODE;
  responseType = responseType!!.split('-').join(' ');
  const loginUrl =
    `${getState().environment.ENV_MODE}` +
    `?client_id=${getState().environment.ENV_MODE}` +
    `&redirect_uri=${callbackUrl}callback` +
    `&response_type=${responseType}` +
    `&scope=app.esim_support`;

  window.location.replace(loginUrl || '');
};



// WEBPACK FOOTER //
// ./src/actions/feedbackAction.ts